export enum Screen {
  appointement = 'appointement',
  disclaimer = 'disclaimer',
  message = 'message',
  confirmation = 'confirmation',
}

declare global {
  interface Window {
    dataLayer?: Array<{
      event?: string
      action?: string
      category?: string
      label?: string
      [key: string]: any
    }>
    OneTrust?: {
      ToggleInfoDisplay: () => void
    }
    Optanon?: {
      ToggleInfoDisplay: () => void
    }
    OptanonWrapper?: any
  }
}
